export default "__VITE_ASSET__aa9daf3a__"